module.exports = __webpack_public_path__ + "img/y-79.9038fe4e.png";